/**
 * useCouponTokens
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import CouponTokensContext from './coupon-tokens-context'

const useCouponTokens = () => {
  const context = useContext(CouponTokensContext)
  return context
}

export default useCouponTokens
